// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"319":"d335b4e9","693":"110cb599","845":"9fe1a8b5","983":"1eccc992"}[chunkId] + ".chunk.js";
};